import {
  ITennisLiveScore,
  TennisLiveScore
} from "@sky-it-livedata/livedata-sports-design-system";
import { useIntcmp } from '../../hooks/useIntcmp';

import { log } from "../../utils/log";
import { transformQuery } from "./transformers/query";
import { LiveScoreData } from "./types";
import { useSubscription } from "../../hooks/useSubscription";
import { LiveScoreSubscriptionData } from "./types";
import { transformSubscription } from "./transformers/subscription";
import { graphql } from "cdk/graphql";
import { WidgetContext } from "../../types/WidgetContext";

export const setCustomAttributes = ({variables}: WidgetContext<LiveScoreData>) => {
  return {
    variables: JSON.stringify(variables),
  };
}

const subscriptionDocument = graphql("subscription onUpdateLiveScoreById {\n  onUpdateLiveScoreById(id: \"unique\") {\n    id\n    liveTournaments {\n      competitionId\n      tourYear\n      categoryName\n      tourName\n      tournamentName\n      tournamentType\n      resultsUrl\n      matches {\n        status\n        startDate\n        roundName\n        resultType\n        firstPosition {\n          isServing\n          players {\n            name\n            nationality\n            seed\n          }\n          score {\n            isWinner\n            set\n            tie\n          }\n          gamePoints\n        }\n        secondPosition {\n          isServing\n          players {\n            name\n            nationality\n            seed\n          }\n          score {\n            isWinner\n            set\n            tie\n          }\n          gamePoints\n        }\n      }\n    }\n    ctaUrls {\n      atpCalendarUrl\n      wtaCalendarUrl\n      atpRankingUrl\n      wtaRankingUrl\n    }\n  }\n}");

export function getServerProps({
  props,
}: WidgetContext<LiveScoreData>): ITennisLiveScore {
  return transformQuery(props);
}

const LiveScore = ({props,
  variables,
  ...rest
}: WidgetContext<ITennisLiveScore>) => {
  log({ props, variables, ...rest });
  const intCmpEventHandler = useIntcmp();

  const updatedProps = useSubscription<
    ITennisLiveScore,
    LiveScoreSubscriptionData,
    typeof subscriptionDocument
  >({
    initialData: props,
    graphQLDocument: subscriptionDocument,
    variables,
    // @ts-ignore  //There's no issue here, transformSubscription returns a subset of ITennisLiveScore, and mergeData is set to true, so the return type will be ITennisLiveScore
    transform: transformSubscription,
    mergeData: true,
  }) as ITennisLiveScore;
  
  return (
    <div onClick={intCmpEventHandler}>
      <TennisLiveScore {...updatedProps}/>
    </div>
  );
}

export default LiveScore;